import type { FC } from 'react';

import RichText from '@eneco/components/RichText/RichText';
import { Box, NotificationBox, Stack } from '@eneco/sparky';
import { Placeholder } from '@sitecore/common';
import { PaginatedContentRendering } from '@sitecore/types/manual/PaginatedContent';

import { Articles } from './Components/Articles';
import { Controls } from './Components/Controls';
import { usePagination } from './UsePagination';


const PaginatedContent: FC<PaginatedContentRendering> = ({
  fields: {
    errorNotification,
    templates,
    tags,
    pageSize,
    nextButtonLabel,
    previousButtonLabel,
    pageLinkLabel,
    navAriaLabel,
  },
}) => {
  const { index, isError, isLoading, indexLimit, articles, articlesPerPage } = usePagination(tags, templates, pageSize);
  return (
    <Stack>
      <Box paddingBottom={{ initial: 8, md: 16 }}>
        {isError ? (
          <Stack.Item>
            <NotificationBox
              isAlert
              text={<RichText html={errorNotification.value.content} />}
              title={errorNotification.value.title}
              variant={errorNotification.value.variant}
            />
          </Stack.Item>
        ) : (
          <Articles isLoading={isLoading} articles={articles} articlesPerPage={articlesPerPage} />
        )}
      </Box>
      <Placeholder name="jss-paginated-content-footer" />
      <Controls
        index={index}
        indexLimit={indexLimit}
        nextButtonLabel={nextButtonLabel.value}
        previousButtonLabel={previousButtonLabel.value}
        pageLinkLabel={pageLinkLabel.value}
        navAriaLabel={navAriaLabel.value}
      />
    </Stack>
  );
};

export { PaginatedContent };
export default PaginatedContent;
